// extracted by mini-css-extract-plugin
export default {"body":"FavoritesPage_body__7Yl9j"};